import { render, staticRenderFns } from "./TransactionRow.vue?vue&type=template&id=5ed4ad84&"
import script from "./TransactionRow.vue?vue&type=script&lang=js&"
export * from "./TransactionRow.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports